import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "logo-facebook",
  "use": "logo-facebook-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"logo-facebook\">\n  <g id=\"logo-facebook_Facebook\">\n    <path fill=\"currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.82,4c0.592,0,2.018,0,2.018,0v1.995c0,0-0.598,0.009-1.334,0.009 c-0.735,0-0.72,0.728-0.72,0.728l-0.007,1.268h2.074v2.001h-2.074l0.014,6H8.693l0.011-6H7.149V7.999h1.555 c0,0-0.009-0.832-0.009-1.934C8.695,4.964,9.52,4.019,10.82,4z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol